import React from 'react';
import './new_a_propos.css'

const Card_Title = ({
  subtitle = "POURQUOI NOUS CHOISIR ?",
  title = "Un besoin, une solution personnalisée"
}) => {
  return (
    <div className='new_a_propos_2025'>
      <div className='Card_Title_block1'>
        <div className='Card_Title_block2'>
          {subtitle}
        </div>
        <div className='Card_Title_block3'>
          {title}
        </div>
      </div>
    </div>
  );
};

export default Card_Title;

